import { createFileRoute } from "@tanstack/react-router"
// Placeholder index for /c/_menuLayout — the parent layout (Menu + shell)
// renders the actual menu content. This file exists only so that the URL "/c"
// resolves to a child of _menuLayout and matches the outlet.
export const Route = createFileRoute("/c/_menuLayout/")({
  component: () => null,
});